/**
 * RidesSecurityService
 * Campus security: expected drivers for a campus/day, listing detail, pickup/drop-off checks,
 * record a physical document check.
 * Route: rides/api/rides/security (roles Admin,RidesAdmin,RidesSecurity; right Rides.Security.Check)
 */
import { BaseService } from '../base/BaseService';
import { unwrapRidesResponse as unwrap } from './unwrapRidesResponse';
/** Security desk service (JWT + role). */
export class RidesSecurityService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RidesSecurityService.DEFAULT_SERVICE_PATH,
            basePath: RidesSecurityService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** GET api/rides/security/expected?locationId&date&eventId&serviceTimeId — drivers expected at a campus. */
    async getExpected(query) {
        return unwrap(await this.getExpectedRaw(query), 'Expected rides not found');
    }
    getExpectedRaw(query) {
        return this.http.get(this.buildUrlWithParams('expected', {
            locationId: query.locationId,
            date: query.date,
            eventId: query.eventId,
            serviceTimeId: query.serviceTimeId,
        }));
    }
    /** GET api/rides/security/availability/{id} — listing with its bookings and checks. */
    async getAvailability(id) {
        return unwrap(await this.getAvailabilityRaw(id), `Ride listing ${id} not found`);
    }
    getAvailabilityRaw(id) {
        return this.http.get(this.buildUrl(`availability/${id}`));
    }
    /** POST api/rides/security/checks — record a pickup / drop-off check mark. */
    async recordCheck(request) {
        return unwrap(await this.recordCheckRaw(request), 'Failed to record security check');
    }
    recordCheckRaw(request) {
        return this.http.post(this.buildUrl('checks'), request);
    }
    /** POST api/rides/security/verifications/{userId}/{typeId}/record — physical document check outcome (Rides.Verification.Record). */
    async recordVerification(userId, typeId, request) {
        return unwrap(await this.recordVerificationRaw(userId, typeId, request), 'Failed to record verification');
    }
    recordVerificationRaw(userId, typeId, request) {
        return this.http.post(this.buildUrl(`verifications/${encodeURIComponent(userId)}/${typeId}/record`), request);
    }
    // ---- documents (254g; only while settings.showDocumentsToSecurity) ----
    /** GET api/rides/security/users/{userId}/documents — a driver's documents with a file (403 when the setting is off). */
    async getUserDocuments(userId) {
        return (await this.getUserDocumentsRaw(userId)).data ?? [];
    }
    getUserDocumentsRaw(userId) {
        return this.http.get(this.buildUrl(`users/${encodeURIComponent(userId)}/documents`));
    }
    /** GET api/rides/security/documents/{id}/view — short-lived signed link (logged). */
    async getDocumentLink(rideUploadId) {
        return unwrap(await this.getDocumentLinkRaw(rideUploadId), 'Document not available');
    }
    getDocumentLinkRaw(rideUploadId) {
        return this.http.get(this.buildUrl(`documents/${rideUploadId}/view`));
    }
}
RidesSecurityService.DEFAULT_SERVICE_PATH = 'rides';
RidesSecurityService.BASE_PATH = 'api/rides/security';
//# sourceMappingURL=RidesSecurityService.js.map